// @ts-strict-ignore
import { components } from 'react-select';

type Props = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  innerProps: Record<string, any>;
};

export function MultiValueRemove({ innerProps, ...otherProps }: Props) {
  return (
    <components.MultiValueRemove
      innerProps={{
        'data-qa-id': 'react-select-remove',
        ...innerProps,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
    />
  );
}
